// ES module-style import
// import Bugsnag from '@bugsnag/js'
// import BugsnagPluginReact from '@bugsnag/plugin-react'
import React from 'react'
import { render } from 'react-dom'

import Application from 'components/app'
import versionStore from 'stores/version'

import toastr from 'components/toastr-config'

import { HashRouter } from 'react-router-dom'
import { ErrorBoundary } from 'react-error-boundary'

import * as Sentry from '@sentry/react'

// Bugsnag.start({
//   apiKey: '7e6b9a04a5245bcecb56f983de9270b3',
//   plugins: [new BugsnagPluginReact()],
//   appType: 'client',
//   onUnhandledRejection: (err, report) => console.log('[PGDBG] Unhandled Rejection', err, report),
//   enabledBreadcrumbTypes: ['navigation', 'request', 'user', 'log'],
//   enabledErrorTypes: {
//     unhandledExceptions: true,
//     unhandledRejections: false,
//   },
//   beforeSend: (report) => console.log('[PGDBG]: Bugsnag Sending report', report),
//   // maxEvents: 10,
//   enabledReleaseStages: ['production', 'staging'],
// })

// Create the error boundary...
// const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)

console.log('Sentry Key: ', process.env.SENTRY_KEY, process.env)
if (process.env.SENTRY_KEY) {
  Sentry.init({
    dsn: `https://${process.env.SENTRY_KEY}@sentry.zuppler.com/5`,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/cs\.zuppler\.test/,
      /^https:\/\/customer-service\.zuppler\.com/,
      /^https:\/\/customer-service\.biznettechnologies\.com/,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    environment: process.env.NODE_ENV || 'staging',
  })
}

const ErrorView = ({ error, resetErrorBoundary }): JSX.Element => {
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  )
}

versionStore.onValue((version) => {
  toastr.info('There is a new version available. Click to update!', 'Customer Service', {
    timeOut: 0,
    onclick: () => window.location.reload(),
  })
})

const routes = () => (
  <ErrorBoundary FallbackComponent={ErrorView}>
    <HashRouter>
      <Application />
    </HashRouter>
  </ErrorBoundary>
)

console.log('Starting Customer Service ')
render(routes(), document.getElementById('react-container'))
